var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import axios from "axios";
let CreateUser = class CreateUser extends Vue {
    user = {};
    roles = {};
    create() {
        axios.post('/api/users', { user: this.user }).then((response) => {
            if (response.status == 201) {
                this.$router.push('/userlist');
            }
        });
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getRoles;
            this.$store.state.monitor = false;
        }
        else {
            this.$router.push('/login');
        }
    }
    get getRoles() {
        axios.get('/api/roles').then((response) => {
            this.roles = response.data.data;
        });
        return this.roles;
    }
};
CreateUser = __decorate([
    Component({
        name: "CreateUser",
    })
], CreateUser);
export default CreateUser;
